<div class="c-field-path-suggestions-container">
  <div class="c-field-path-chip__label">{{'COMMON.FIELD_NAME' | translate}}</div>
  <div class="c-field-path-chip-container" (click)="focusInput()" [class.disabled]="currentInput.disabled">
    <div #triggerOrigin>
      <span *ngFor="let segment of segments; let i = index; let last = last" class="segment-item">
        <span class="c-field-path-chip">
          {{ segmentLabels[i] || (segment | titlecase) }}
        </span>
        <span class="c-field-path__dot" *ngIf="!last">.</span>
      </span>
      <span class="c-field-path__dot" *ngIf="segments.length > 0 && canEnterMoreSegments">.</span>
      <span class="c-field-path-input-wrapper" *ngIf="canEnterMoreSegments || isFinalEditable">
        <input #pathInputField
          class="c-field-path__input-path"
          [formControl]="currentInput"
          (keydown)="onInputKeyDown($event)"
          (click)="onInputClick()"
          [placeholder]="showPlaceholder ? 'Enter field path...' : ''">
      </span>
    </div>
    <button type="button"
      class="c-field-path__btn-remove"
      *ngIf="segments.length > 0"
      (click)="clearPath(); $event.stopPropagation()"
      [disabled]="currentInput.disabled"
      aria-label="Clear path">
      &times;
    </button>
  </div>
</div>

<!-- CDK Overlay Template -->
<ng-template cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerOrigin"
    (backdropClick)="onBackdropClick()"
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayPositions]="connectedPositions"
    [cdkConnectedOverlayWidth]="triggerRect?.width"
    (overlayOutsideClick)="onOverlayOutsideClick()">

  <div class="c-field-path-suggestions__dropdown-list"
    [ngClass]="isDropdownOpen? 'c-field-path-suggestions__dropdown-list--has-border' : ''">
    <ul *ngIf="!(isLoadingSuggestions$ | async)">
      <li *ngFor="let suggestion of (suggestions$ | async)"
        (mousedown)="selectSuggestion(suggestion); $event.preventDefault()">
        {{ suggestion.label }}
        <small style="color: grey; margin-left: 10px;">({{ suggestion.field.type }})</small>
      </li>
      <li *ngIf="(suggestions$ | async)?.length === 0">No suggestions found.</li>
    </ul>
    <div class="loading-indicator" *ngIf="isLoadingSuggestions$ | async">
      Loading...
    </div>
  </div>
</ng-template>
